module.exports = __webpack_public_path__ + "static/img/areaA_6.6725fde.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/areaA_6.png
// module id = 1069
// module chunks = 1